import ReservationForm from "../../components/ReservationForm";

export default function CreateReservation() {
  return (
    <>
      <h1 className="title">Create Reservation</h1>
      <ReservationForm />
    </>
  );
}